import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "./Club.module.css";

function Club() {
    const [clubData, setClubData] = useState([]);
    const [loading, setLoading] = useState(true);

    // Default Club videos - these will ALWAYS be shown
    const defaultClubVideos = [
        { videoId: "XxiOxCsgfRw", name: "Affiliate Ritual Event 1", timestamp: 0 },
        { videoId: "yeuuMOPVdSk", name: "Affiliate Ritual Event 2", timestamp: 0 },
        { videoId: "2Lg7-B4mnkk", name: "Affiliate Ritual Event 3", timestamp: 0 },
        { videoId: "GcdbhiMxkIA", name: "Affiliate Ritual Event 4", timestamp: 0 },
        { videoId: "bdLHtrJOOeY", name: "Affiliate Ritual Event 5", timestamp: 0 },
        { videoId: "PpkcXIPMFME", name: "Affiliate Ritual Event 6", timestamp: 0 },
    ];

    // Set default videos directly
    useEffect(() => {
        setClubData(defaultClubVideos);
        setLoading(false);
    }, []);

    const CustomPrevArrow = (props) => {
        const { onClick } = props;
        return <div className={`${styles.customArrow} ${styles.prev}`} onClick={onClick} />;
    };

    const CustomNextArrow = (props) => {
        const { onClick } = props;
        return <div className={`${styles.customArrow} ${styles.next}`} onClick={onClick} />;
    };

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: true,
        arrows: true,
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
        responsive: [
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 1,
                }
            },
        ]
    };

    if (loading) {
        return (
            <div>
                <p className={styles.clubParagraph}>
                    Hear From Our Club Leader And Club Member
                </p>
                <div style={{ textAlign: 'center', padding: '2rem', color: 'white' }}>
                    Loading videos...
                </div>
            </div>
        );
    }

    return (
        <div>
            <p className={styles.clubParagraph}>
                Hear From Our Club Leader And Club Member
            </p>

            <div className="slider-container">
                <Slider {...settings} className={styles.clubItemContainer}>
                    {clubData.map((item, i) => (
                        <LazyYouTube key={i} videoId={item.videoId} timestamp={item.timestamp} />
                    ))}
                </Slider>
            </div>
        </div>
    );
}

export default Club;

// Lazy Load YouTube Iframes
const LazyYouTube = ({ videoId, timestamp = 0 }) => {
    const [isPlaying, setIsPlaying] = useState(false);

    return (
        <div className={styles.clubItem} onClick={() => setIsPlaying(true)}>
            {!isPlaying ? (
                <img
                    className={styles.clubImg}
                    src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
                    alt="Video Thumbnail"
                    loading="lazy"
                />
            ) : (
                <iframe
                    className={styles.clubVideo}
                    src={`https://www.youtube.com/embed/${videoId}?autoplay=1&controls=1&modestbranding=1&rel=0&start=${timestamp}`}
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    title="YouTube video player"
                ></iframe>
            )}
        </div>
    );
};

